import LogoOutline from './logo-outline.svg';

export default LogoOutline;
